import React from 'react';

import Landing from '../Components/Landing';
import Stories from './Stories';

const Home = () => {
  // The home page

  return (
    <div 
    className='container flex-column' 
    style={{ 
      width: '100%', 
      height: '100%' 
      }}>
      
      {/* render the landing page */}
      <Landing />
      
      {/* render the stories page */}
      <Stories />
    
    </div>
  );
};

export default Home;
